// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2OcEB","notes":"Notes_notes__3p0no"};